export const formatRows = (listaItems, tipoprecio) => {
  return listaItems.map((item) => {
    const precio =
      Number(tipoprecio) === 0
        ? item.art_npreciomayorista || 0 // Valor predeterminado como número
        : item.art_nprecioventa || 0;

    const descuento = item.descuento ? `${item.descuento} %`: "0"; // Si no hay descuento, asignar 0
      
    const totaloferta = item.descuento ? 
     `$${Math.max(Number(precio * ((100 - Number(item.descuento)) / 100)).toFixed(2), 0)}` 
          :  "0"; // Si no hay descuento, asignar 0.00

    return {
      id: item.id || "Información no disponible",
      codigo: item.art_codigo || "Información no disponible",
      descripcion: item.art_descripcion || "Información no disponible",
      costo: item.art_npreciocosto || 0,
      precio: `$${Number(precio).toFixed(2)}` || 0, // Formato monetario consistente
      descuento: descuento, // Si no hay descuento, será 0
      totaloferta: totaloferta || 0, // Si no hay descuento, será 0.00
      totalstock: item.stock || 0, // Predeterminar stock como 0 si no está disponible
    };
  });
};
